import { motion } from 'framer-motion';

const clientLogos = [
  { name: 'University of Kansas', img: 'https://cdn.flynaut.com/images/KUSig_Horz_Web_White.png', makeWhite: false },
  { name: 'Southern Bank', img: 'https://cdn.flynaut.com/images/southern-bank-logo-white.webp', makeWhite: false },
  { name: 'Maybach', img: 'https://cdn.flynaut.com/images/maybach_white.svg', makeWhite: false },
  { name: 'US Bank', img: 'https://cdn.flynaut.com/images/USB_BIG.D-e6258430.png', makeWhite: false },
  { name: 'Cumberland County NC', img: 'https://cdn.flynaut.com/images/Horizontal_County_Logo (1).png', makeWhite: true },
  { name: 'GE', img: 'https://cdn.flynaut.com/images/GE-logo-white.png', makeWhite: false },
  { name: 'Toyota', img: 'https://cdn.flynaut.com/images/toyota-logo-png-30.png', makeWhite: false },
  { name: 'Cummins', img: 'https://cdn.flynaut.com/images/diesel-generators-in-sri-lanka-elevator-systems-lifts-cummins-png-logo-4.png', makeWhite: false },
  { name: 'Meggitt', img: 'https://cdn.flynaut.com/images/5Client_logo_stack.webp', makeWhite: false },
];

function LogoItem({ logo }) {
  return (
  <div
  data-testid={`trusted-logo-${logo.name.toLowerCase().replace(/\s+/g, '-')}`}
  className="flex items-center justify-center h-8 opacity-80 hover:opacity-100 transition-all duration-200 cursor-default flex-shrink-0"
  title={`${logo.name} - Flynaut client`}
  >
  <img
  src={logo.img}
  alt={logo.name}
  className="h-full w-auto max-w-[140px] object-contain"
  style={logo.makeWhite ? { filter: 'brightness(0) invert(1)' } : {}}
  loading="lazy"
  />
  </div>
  );
}

export default function TrustBar() {
  return (
  <section data-testid="trust-bar-section" className="bg-[#1A202C] py-8 md:py-10">
  <div className="max-w-content mx-auto px-6">
  <motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  transition={{ duration: 0.5 }}
  className="text-center text-[#CBD5E0] text-sm font-medium mb-8"
  >
  Trusted by teams building what matters.
  </motion.p>

  {/* Marquee logo strip */}
  <motion.div
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6, delay: 0.1 }}
  className="overflow-hidden"
  >
  <div className="marquee-scroll flex items-center gap-14 w-max">
  {[...clientLogos, ...clientLogos].map((logo, i) => (
  <LogoItem key={`${logo.name}-${i}`} logo={logo} />
  ))}
  </div>
  </motion.div>
  </div>
  </section>
  );
}
